import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    class: "container p-0",
    style: { "flex": "1 1 0" }
};
const _hoisted_2 = { class: "row" };
const _hoisted_3 = { class: "col-md-12" };
const _hoisted_4 = { class: "row" };
const _hoisted_5 = { class: "col-md-6" };
const _hoisted_6 = { class: "col-md-6" };
const _hoisted_7 = { class: "row" };
const _hoisted_8 = { class: "col-md-6" };
const _hoisted_9 = { class: "col-md-6" };
const _hoisted_10 = { class: "row" };
const _hoisted_11 = { class: "col-md-12" };
const _hoisted_12 = { class: "row" };
const _hoisted_13 = { class: "col-md-12" };
const _hoisted_14 = { class: "row" };
const _hoisted_15 = { class: "col-md-12" };
const _hoisted_16 = { class: "row" };
const _hoisted_17 = { class: "col-md-12" };
const _hoisted_18 = { class: "row" };
const _hoisted_19 = { class: "col-md-12" };
const _hoisted_20 = { class: "row" };
const _hoisted_21 = { class: "col-md-5" };
const _hoisted_22 = { class: "col-md-7" };
const _hoisted_23 = { class: "row" };
const _hoisted_24 = { class: "col-md-12" };
const _hoisted_25 = {
    key: 0,
    class: "row"
};
const _hoisted_26 = { class: "col-md-12" };
const _hoisted_27 = { class: "mb-3 error__message-container" };
const _hoisted_28 = { class: "row align-middle" };
const _hoisted_29 = { class: "col-sm-5 text-right pl-0" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_text_field = _resolveComponent("g-text-field");
    const _component_g_button = _resolveComponent("g-button");
    const _component_g_simple_page = _resolveComponent("g-simple-page");
    return (_openBlock(), _createBlock(_component_g_simple_page, {
        "show-logo": false,
        title: "Registrieren",
        "back-link-path": "/login"
    }, {
        default: _withCtx(() => [
            _createElementVNode("form", null, [
                _createElementVNode("div", _hoisted_1, [
                    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "row mb-3 small" }, [
                        _createElementVNode("div", { class: "col-md-12" }, " Für die Registierung am Web-Portal geben Sie bitte Ihre Daten ein. Sobald wir Ihre Angeben geprüft haben, erhalten Sie einen Zugang. ")
                    ], -1)),
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createVNode(_component_g_text_field, {
                                member: "registration.eMail",
                                label: "eMail-Adresse*",
                                dataObject: _ctx.$data,
                                "show-clear-button": true
                            }, null, 8, ["dataObject"])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                            _createVNode(_component_g_text_field, {
                                member: "registration.password",
                                label: _ctx.$t('account.Password.Registration.Password') + '*',
                                dataObject: _ctx.$data,
                                mode: "password"
                            }, null, 8, ["label", "dataObject"])
                        ]),
                        _createElementVNode("div", _hoisted_6, [
                            _createVNode(_component_g_text_field, {
                                member: "registration.confirmPassword",
                                label: _ctx.$t('account.Password.Registration.Confirm') + '*',
                                dataObject: _ctx.$data,
                                mode: "password"
                            }, null, 8, ["label", "dataObject"])
                        ])
                    ]),
                    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "row mb-2" }, [
                        _createElementVNode("div", {
                            class: "col-md-12 text-muted",
                            style: { "font-size": ".7em" }
                        }, " Das Kennwort muss mindestens 8 Zeichen lang sein, einen Kleinbuchstaben, einen Großbuchstaben, eine Ziffer und ein Sonderzeichen enthalten. Es muss mindestens ein eindeutiges Zeichen enthalten sein. ")
                    ], -1)),
                    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "row" }, [
                        _createElementVNode("div", { class: "col-md-12" }, [
                            _createElementVNode("hr", { class: "m-0 mb-1" })
                        ])
                    ], -1)),
                    _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                            _createVNode(_component_g_text_field, {
                                member: "registration.firstName",
                                label: "Vorname*",
                                dataObject: _ctx.$data,
                                "show-clear-button": true
                            }, null, 8, ["dataObject"])
                        ]),
                        _createElementVNode("div", _hoisted_9, [
                            _createVNode(_component_g_text_field, {
                                member: "registration.lastName",
                                label: "Nachname*",
                                dataObject: _ctx.$data,
                                "show-clear-button": true
                            }, null, 8, ["dataObject"])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                            _createVNode(_component_g_text_field, {
                                member: "registration.telephone",
                                label: "Telefonnummer*",
                                dataObject: _ctx.$data,
                                "show-clear-button": true
                            }, null, 8, ["dataObject"])
                        ])
                    ]),
                    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "row" }, [
                        _createElementVNode("div", { class: "col-md-12" }, [
                            _createElementVNode("hr", { class: "m-0 mb-1" })
                        ])
                    ], -1)),
                    _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                            _createVNode(_component_g_text_field, {
                                member: "registration.address_name1",
                                label: "Name 1*",
                                dataObject: _ctx.$data,
                                "show-clear-button": true
                            }, null, 8, ["dataObject"])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, [
                            _createVNode(_component_g_text_field, {
                                member: "registration.address_name2",
                                label: "Name 2",
                                dataObject: _ctx.$data,
                                "show-clear-button": true
                            }, null, 8, ["dataObject"])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, [
                            _createVNode(_component_g_text_field, {
                                member: "registration.address_addition",
                                label: "Zusatz",
                                dataObject: _ctx.$data,
                                "show-clear-button": true
                            }, null, 8, ["dataObject"])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("div", _hoisted_19, [
                            _createVNode(_component_g_text_field, {
                                member: "registration.address_street",
                                label: "Straße*",
                                dataObject: _ctx.$data,
                                "show-clear-button": true
                            }, null, 8, ["dataObject"])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("div", _hoisted_21, [
                            _createVNode(_component_g_text_field, {
                                member: "registration.address_zipcode",
                                label: "Postleitzahl*",
                                dataObject: _ctx.$data,
                                "show-clear-button": true
                            }, null, 8, ["dataObject"])
                        ]),
                        _createElementVNode("div", _hoisted_22, [
                            _createVNode(_component_g_text_field, {
                                member: "registration.address_city",
                                label: "Ort*",
                                dataObject: _ctx.$data,
                                "show-clear-button": true
                            }, null, 8, ["dataObject"])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("div", _hoisted_24, [
                            _createVNode(_component_g_text_field, {
                                member: "registration.euvatid",
                                label: "Umsatsteuer-ID*",
                                dataObject: _ctx.$data,
                                "show-clear-button": true
                            }, null, 8, ["dataObject"])
                        ])
                    ]),
                    (_ctx.hasErrors(_ctx.$form.results))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                            _createElementVNode("div", _hoisted_26, [
                                _createElementVNode("div", _hoisted_27, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filterErrors(_ctx.$form.results), (item, index) => {
                                        return (_openBlock(), _createElementBlock("div", null, _toDisplayString(item.message), 1));
                                    }), 256))
                                ])
                            ])
                        ]))
                        : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_28, [
                    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "col-sm-7 my-auto text-left align-middle pr-0" }, null, -1)),
                    _createElementVNode("div", _hoisted_29, [
                        _createVNode(_component_g_button, {
                            text: "Registrieren",
                            disabled: _ctx.disableSubmit,
                            onClick: _ctx.OnExecute
                        }, null, 8, ["disabled", "onClick"])
                    ])
                ])
            ])
        ]),
        _: 1
    }));
}
